import React, { useEffect, useState } from 'react'
import { app } from '../../config';
import axios from 'axios';
import getHeaders from '../../utils/authHeaders';
import { UpdateRecord } from '../../layouts/UpdateRecord';
import { InputField } from '../../layouts/FormFields';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const EditFacialPackage = () => {
  const [updatedData, setUpdatedData] = useState({});
  const [loading, setLoading] = useState(false);

   const [uploadObj, setUploadObj] = useState({});
   let [show, setShow] = useState(false);
    
   const [addUserResp, setAddUserResp] = useState({});
  let navigate = useNavigate();
    
    
    
    

    
let facialPackageId = localStorage.getItem('facialPackageId');

let getPackage = async () => {
    try {
      console.log(`${app.URL}/api/v1/admin/facialpackages/view?facialPackageId=${facialPackageId}`);
    let res = await axios.get(`${app.URL}/api/v1/admin/facialpackages/view?facialPackageId=${facialPackageId}`, { headers: getHeaders() });
    setLoading(false);
    console.log('resres', res);

    res.data?.result?.data ? setUpdatedData(res.data?.result?.data) : '';
  } catch (err) {
    console.log(err);
  }
    };
    console.log('updatedData', updatedData);

useEffect(() => {
  setLoading(true);
  getPackage();
}, []);
   
  const uploadData = async (uploadObj) => {
    console.log('here uploadObj' , uploadObj);
 
    setLoading(true);

    try {
      //  return
      const res = await axios.put(`${app.URL}/api/v1/admin/facialpackages/update?facialPackageId=${facialPackageId}`, uploadObj, { headers: getHeaders() });
      console.log(res);

      if (res.data.result.success) {
        setAddUserResp(res.data.result);
        message.success(res.data.result.msg);
        setTimeout(() => {
          navigate('/facialpackages/listing');
        }, 1000);
      } else if (!res.data.result.success) {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      setLoading(false);
      setShow(false);

      console.log(err);
      if (err) console.log(err.response.data.message);
      else return;
    }
  };

    const onFinish = (values) => {
          console.log("success",values)
        setUploadObj(values);
        setShow(true);
        // return;
      };
      console.log(uploadObj);
      const handleClose = () => setShow(false);

      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    const submitData = () => {
      console.log('calling: ', uploadObj);

      if (Object.keys(uploadObj).length > 0) {
        uploadData(uploadObj);
      }
    };

 function goBack() {
   navigate('/facialpackages/listing', { replace: true });
 }    return (
   <div>
     <UpdateRecord
       pageTitle='Edit Vital Package'
       loading={loading}
       response={updatedData}
       onFinish={onFinish}
       addUserResp={addUserResp}
       updateMessage='Are you sure you want to Vital Package?'
       onFinishFailed={onFinishFailed}
       initialValues={{
         remember: true,
         ['isActive']: updatedData?.isActive,
         // ['viewType']: 'Image',
         ['name']: updatedData?.name,
         ['scans']: updatedData?.scans,
         ['validity']: updatedData?.validity,
         ['pricing']: updatedData?.pricing,
       }}
       inputs={[
         <div className='col-lg-8'>
           <div className='row'>
             <InputField
               col='col-md-6 col-12'
               name='name'
               label='PackageName'
               rules={[
                 {
                   required: true,
                   message: 'Enter PackageName',
                 },
               ]}
               placeholder='Enter PackageName'
               required={true}
             />
             <InputField
               col='col-md-6 col-12'
               name='scans'
               label='Scans'
               rules={[
                 {
                   required: true,
                   message: 'Enter Scans',
                 },
               ]}
               placeholder='Enter Scans'
               required={true}
             />
             <InputField
               col='col-md-6 col-12'
               name='validity'
               label='Validity'
               rules={[
                 {
                   required: true,
                   message: 'Enter Validity',
                 },
               ]}
               placeholder='Enter Validity'
               required={true}
             />
             <InputField
               col='col-md-6 col-12'
               name='pricing'
               label='Pricing'
               rules={[
                 {
                   required: true,
                   message: 'Enter Pricing',
                 },
               ]}
               placeholder='Enter Pricing'
               required={true}
             />
           </div>
         </div>,
       ]}
       upload={false}
       // vdoupload={videoupload}
       // action={`${app.URL}/api/v1/general/user/imageupload`}
       // beforeUpload={beforeUpload}
       // handleuploadChange={handleuploadChange}
       // imageuploading={imageuploading}
       submitData={submitData}
       // uploadedImg={uploadedImg}
       // setUploadedImg={setUploadedImg}
       // isRichTextEditor={true}
       switchBtn={true}
       goBack={goBack}
       handleClose={handleClose}
       show={show}
       videoUrl={false}
       // onChange={handleEditorChange}
       // textEditorValue={textEditorValue}
       // imgError={imgError}
       // setImgError={setImgError}
     />
   </div>
 );
}

export default EditFacialPackage